import { PTA } from '@aposphaere/core-kit'
import { SectionCard } from '@aposphaere/ui-components'
import React, { useState } from 'react'
import { ModalKind, useModal } from '../../contexts/modalContext'
import PersonenCardItem from './PersonenCardItem'

export interface PersonenCardProps {
  showAddButton: boolean
  employees: PTA[]
  pharmacyId: number
}
const PersonenCard: React.FunctionComponent<PersonenCardProps> = ({ pharmacyId, showAddButton, employees }) => {
  const { openModal } = useModal()

  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <SectionCard
      isExpanded={expanded}
      setExpanded={setExpanded}
      title="Personen"
      showAddButton={showAddButton}
      showAllEntries={employees.length <= 6}
    >
      {employees?.length === 0 ? (
        <p className="w-full py-2 text-base text-gray-600 text-center">{'Keine Einträge vorhanden'}</p>
      ) : (
        employees?.map((employee) => (
          <PersonenCardItem
            key={employee.id}
            employee={employee}
            onOpenModal={() => openModal({ kind: ModalKind.PersonenEdit, id: Number(employee.id), pharmacyId: pharmacyId })}
            canEditEmployee
          />
        ))
      )}
    </SectionCard>
  )
}
export default PersonenCard
